import styled from 'styled-components';
export const StyledModalContainer = styled.div<{
  uppercaseTitle?: boolean;
}>`
  h2,
  p {
    color: ${({
  theme
}) => theme.colors.white};
  }

  h2 {
    font-size: ${({
  theme
}) => theme.fonts.sizes.subTitle};
    text-transform: ${({
  uppercaseTitle
}) => uppercaseTitle ? 'uppercase' : 'none'};
    font-family: ${({
  theme,
  uppercaseTitle
}) => uppercaseTitle ? theme.fonts.familySansPro : theme.fonts.familyUbuntu};
    font-weight: ${({
  theme,
  uppercaseTitle
}) => uppercaseTitle ? 900 : theme.fonts.weight.semiBold};
  }

  p span,
  h2 span {
    color: ${({
  theme
}) => theme.colors.primary.main};
  }

  p {
    font-size: 2.4rem;
    font-weight: ${({
  theme
}) => theme.fonts.weight.bold};
    line-height: 3rem;
    margin-bottom: 2.4rem;
  }
`;
export const StyledCampaignTitle = styled.span`
  color: ${({
  theme
}) => theme.colors.primary.main};
  font-weight: ${({
  theme
}) => theme.fonts.weight.bolder};
  text-transform: uppercase;
  margin: 2rem 0;
  font-size: ${({
  theme
}) => theme.fonts.sizes.default};
  display: block;
`;
export const StyledTag = styled.div`
  margin: 2.4rem 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.8rem;
  width: 100%;
  span {
    background: rgba(45, 61, 95, 1);
    color: rgba(113, 156, 249, 1);
    padding: 0.7rem 1.2rem;
  }
`;